var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 8.49977C2 4.91005 4.91005 2 8.49979 2C12.0895 2 14.9996 4.91005 14.9996 8.49977C14.9996 12.0895 12.0895 14.9995 8.49979 14.9995C4.91005 14.9995 2 12.0895 2 8.49977ZM8.49979 0C3.80549 0 0 3.80548 0 8.49977C0 13.1941 3.80549 16.9995 8.49979 16.9995C10.4869 16.9995 12.3148 16.3176 13.7622 15.1751C13.7721 15.1859 13.7823 15.1966 13.7928 15.2071L18.2926 19.7069C18.6832 20.0974 19.3163 20.0974 19.7069 19.7069C20.0974 19.3164 20.0974 18.6832 19.7069 18.2927L15.207 13.7928C15.1965 13.7824 15.1858 13.7722 15.175 13.7622C16.3176 12.3149 16.9996 10.487 16.9996 8.49977C16.9996 3.80548 13.1941 0 8.49979 0Z",
    fill: "#26282B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.1586ab884c77c95a4d878ff02cac2d84.svg";
export { ForwardRef as ReactComponent };